import * as React from "react";
export function useForceUpdate() {
  var setState = React.useState(emptyObj)[1];
  return React.useRef(function () {
    return setState({});
  }).current;
}
var emptyObj = {};